<script lang="ts" setup>
const { getTeamAttributes } = useApiAttributes()

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/teams/:teamId',
  },
]

const responseAttributes: ApiAttribute[] = getTeamAttributes()

const response = {
  country: 'us',
  createdAt: '2020-06-29 08:21:01',
  credits: 500 * 1000,
  id: 1,
  isSubscriber: true,
  name: 'Jay Gatsby Enterprises',
  websiteUrl: 'https://www.jaygatsbyenterprises.com',
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :response="response"
    :response-attributes="responseAttributes"
  />
</template>
